/**
 * `person` → **Settings** (the deprecated single-person column, spec M2 tier-1 §5.7).
 *
 * monday's second enum name for it is `item_assignees` and `PersonSettings` **is**
 * `PeopleSettings` — the same `settings_str`. The one difference is that the cell holds exactly
 * one person, so `max_people_allowed` has nothing to decide and is not offered; the dialog exists
 * for the summary switch and to say, in the product, that the type is deprecated.
 */
import type { PersonSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function PersonSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<PersonSettings>) {
  const [draft, patch] = useSettingsDraft<PersonSettings>(settings);
  return (
    <SettingsForm
      title="Person column settings"
      testId="person-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <p className="ez-type-settings__hint" data-testid="person-deprecated">
        This column type is deprecated and holds one person. Use a People column for more than one.
      </p>
      <HideSummaryField
        divider={false}
        testId="person-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
